import { render, staticRenderFns } from "./CPArea1.vue?vue&type=template&id=3e282050&scoped=true"
import script from "./CPArea1.vue?vue&type=script&lang=js"
export * from "./CPArea1.vue?vue&type=script&lang=js"
import style0 from "./CPArea1.vue?vue&type=style&index=0&id=3e282050&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e282050",
  null
  
)

export default component.exports